import React from 'react'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { GlobalModalWrapperStyled } from 'Features/MainWrapper/components/GlobalModalWrapper/GlobalModalWrapper.styled'
import { AddDomainModal } from 'Components/Elements/AddDomainModal/AddDomainModal'
import { HelpCenterModal } from 'Components/Elements/HelpCenterModal/HelpCenterModal'
import CqParamsModal from 'Features/CheqParamsModal/CheqParamsModal'
import { PlatformConnectionModal } from 'Features/platformConnectionModal/PlatformConnectionModal'
import { BzSetupPopup } from 'Features/bzSetupPopup/BzSetupPopup'
import { useShowProductConnection } from './useShowProductConnection'
import { CrossSaleModal } from 'Features/MainWrapper/CrossSaleModal/CrossSaleModal'
import { GLOBAL_MODALS } from 'Types/GlobalModal'
import { TrialEndedModal } from 'Features/accountSettings/components/Billing/TrialEndedModal/TrialEndedModal'
import { TrialPreEndModal } from 'Features/accountSettings/components/Billing/TrialPreEndModal/TrialPreEndModal'
// import { useSplit } from 'Hooks/useSplit'
import { DomainReactivationModal } from 'Features/ReactivationPage/DomainReactivationModal/DomainReactivationModal'
import { GoogleDisconnectedModal } from 'Features/GoogleDisconnectedModal/GoogleDisconnectedModal'
import { EditDomainProductsModal } from 'Features/domainsManagement/components/EditDomainProductsModal/EditDomainProductsModal'
import ThreatGroupTooltipModal from '../../../../paidMarketing/features/Dashboard/components/DashboardElements/ThreatGroups/ThreatGroupTooltip/ThreatGroupToolTip'
import { default as PmPlatformsConnectionModal } from '../../../../paidMarketing/features/Platforms/components/PlatformsConnectionModal/ConnectionModal'
import { Platforms } from 'src/paidMarketing/features/Platforms/models'

export const GlobalModalWrapper = () => {
  const {
    pmPlatformConnectionModalStatus,
    setPmPlatformConnectionModal,
    modalToShow,
    setModalToShow,
    currentDomain,
    setCurrentDomain,
  } = useAppStore()
  const { bmDomainAddress } = useShowProductConnection()
  // This split is currently disabled in prod so I commented it out for now
  // const isMultiAccEnabled = useSplit('CE_GOOG_MULTIACC')
  const closeModal = () => setModalToShow('')

  const bmSetupModalDomain: string = currentDomain?.address || bmDomainAddress

  return (
    <GlobalModalWrapperStyled>
      {
        <PmPlatformsConnectionModal
          platform={pmPlatformConnectionModalStatus.platform as Platforms}
          isOpen={Boolean(!modalToShow && pmPlatformConnectionModalStatus.platform)}
          onOpenChange={() => setPmPlatformConnectionModal(false, '')}
          onClose={() => setPmPlatformConnectionModal(false, '')}
          isEdit
          // isMultiAccEnabled={isMultiAccEnabled}
        />
      }
      <ThreatGroupTooltipModal
        style={{ height: 'auto', padding: '0px' }}
        isOpen={modalToShow === GLOBAL_MODALS.THREAT_GROUP_TOOLTIP}
        onOpenChange={closeModal}
      />

      <HelpCenterModal
        isOpen={modalToShow === GLOBAL_MODALS.HELP_CENTER}
        onOpenChange={closeModal}
      />

      {modalToShow === GLOBAL_MODALS.ADD_DOMAIN && <AddDomainModal onOpenChange={closeModal} />}

      <CqParamsModal isOpen={modalToShow === GLOBAL_MODALS.CQ_PARAMS} onOpenChange={closeModal} />

      <PlatformConnectionModal
        isOpen={modalToShow === GLOBAL_MODALS.PLATFORM_CONNECTION}
        onOpenChange={closeModal}
      />

      <TrialEndedModal
        isOpen={modalToShow === GLOBAL_MODALS.TRIAL_ENDED}
        onOpenChange={closeModal}
      />

      <TrialPreEndModal
        isOpen={modalToShow === GLOBAL_MODALS.TRIAL_PRE_END}
        onOpenChange={closeModal}
      />

      {!!bmSetupModalDomain && (
        <BzSetupPopup
          isOpen={modalToShow === GLOBAL_MODALS.BM_SETUP}
          onOpenChange={() => {
            closeModal()
            setCurrentDomain(undefined)
          }}
          domainAddress={bmSetupModalDomain}
        />
      )}

      {modalToShow === GLOBAL_MODALS.EDIT_DOMAIN_PRODUCTS && currentDomain && (
        <EditDomainProductsModal
          domain={currentDomain}
          isOpen={true}
          onOpenChange={(open) => {
            if (!open) {
              closeModal()
              setCurrentDomain(undefined)
            }
          }}
        />
      )}

      {(modalToShow === GLOBAL_MODALS.BM_CROSS_SALE ||
        modalToShow === GLOBAL_MODALS.PM_CROSS_SALE) && <CrossSaleModal modalType={modalToShow} />}

      {modalToShow === GLOBAL_MODALS.DOMAIN_REACTIVATION && <DomainReactivationModal />}

      {modalToShow === GLOBAL_MODALS.GOOGLE_DISCONNECTED && <GoogleDisconnectedModal />}
    </GlobalModalWrapperStyled>
  )
}
